import { AGENTIC_MS_USER_INFO, AUTHORIZATION_TOKEN } from '../constants/appConstants';

export const getAccessToken = () => {
  const data: any = sessionStorage.getItem(AUTHORIZATION_TOKEN);
  if (data) {
    return data
  } else {
    return null;
  }
};

export const getUserInfo = () => {
  const userData: any = sessionStorage.getItem(AGENTIC_MS_USER_INFO);
  const parsedData = JSON.parse(userData);
  return parsedData
}
